// extracted by mini-css-extract-plugin
module.exports = {"header":"StudentsPage_header__17hV0","navigationWrapper":"StudentsPage_navigationWrapper__3UE2_","paginationWrapper":"StudentsPage_paginationWrapper__2Iqoz"};